import type { DefaultTheme } from "../themes";

const cabinetAppBar = (theme: DefaultTheme) =>
  ({
    root: {
      backgroundColor: theme.palette.background.default,
      position: "fixed",
      width: "100%",
      zIndex: theme.zIndex.drawer + 1,
      paddingLeft: theme.spacing(2),
      borderBottom: `1px solid ${theme.palette.transparent.light}`,
    },
  }) as const;

export default cabinetAppBar;
